export enum Media {
  ALBUM = "ALBUM",
  TRACK = "TRACK",
}

export enum CatalogMediaLimit {
  TRACK = 22,
  ALBUM = 20,
  QUICK = 3,
}
